import { createSlice } from "@reduxjs/toolkit";

export const LayoutPage = createSlice({
    name:"LayoutPage",
    initialState:{
        currentPage:0,
        allPages:0,
        pageActive:[],
        currAddPage:0
    },
    reducers:{
        SET_LAYOUT_STATE:(state, action)=>{
            if(action.payload!==null){
                let num = parseInt(action.payload)
                state.allPages = num
                let arr = Array(num).fill(false)
                arr[0] = true
                state.pageActive = arr
            }
        },
        SET_LAYOUTPAGE:(state, action)=>{
            if(action.payload!==null){ 
                let num = parseInt(action.payload)
                state.currentPage = num
                state.pageActive = Array(state.allPages).fill(false)
                state.pageActive[num] = true
            }
        },
        SET_ADDPAGE:(state, action)=>{
            if(action.payload!==null){ 
                let num = parseInt(action.payload)
                state.currAddPage = num
            }
        },
        CLEAR_LAYOUT:(state, action)=>{
            state.currentPage =0
            state.allPages =0
            state.pageActive =[]
            state.currAddPage =0
        }
    },

})

export const {
    SET_LAYOUTPAGE,
    SET_LAYOUT_STATE,
    SET_ADDPAGE,
    CLEAR_LAYOUT
} = LayoutPage.actions

export default LayoutPage.reducer